import { FC, useContext, useEffect, useRef } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../../../context/notificationContext";
import useI18n from "../../../../../hooks/useTranslations";
import { useMembraneProtectionsApi } from "../../../../../http/border/useMembraneProtections";
import MembraneProtectionForm from "./MembraneProtectionForm";

interface EditMembraneProtectionProps {
  onClose: () => void;
  membraneProtectionId: string;
}

const EditMembraneProtection: FC<EditMembraneProtectionProps> = ({ onClose, membraneProtectionId }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const aborter = useRef(new AbortController());
  const membraneProtectionApi = useMembraneProtectionsApi();

  const { data, error, trigger } = membraneProtectionApi.getAdminMembraneProtection(
    membraneProtectionId,
    aborter.current.signal,
  );

  useEffect(() => {
    error && dispatch(showErrorNotification(i18n, error));
  }, [error]);

  useEffect(() => {
    membraneProtectionId && trigger();
  }, [membraneProtectionId]);

  return (
    <MembraneProtectionForm
      onClose={onClose}
      membraneProtection={data}
      isDisabled={!!error}
      isLoading={!data && !error}
    />
  );
};

export default EditMembraneProtection;
